import {Component, OnInit} from '@angular/core';
import {GeneralConstant} from './shared/constants/GeneralConstant';
import {MatIconRegistry} from '@angular/material/icon';
import {customIcons} from './shared/constants/custom-icons';
import {DomSanitizer, Meta} from '@angular/platform-browser';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  themeClass = GeneralConstant.DEFAULT_THEME;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    meta: Meta
  ) {
    this.registerIcons();
    if (!environment.production) {
      meta.addTag({name: 'robots', content: 'noindex'});
    }
  }

  ngOnInit(): void {
    this.loadDefaultTheme();
  }

  loadDefaultTheme() {
    const docClassList = document.body.classList;
    docClassList.remove(docClassList.item(0));
    docClassList.add(this.themeClass);
  }

  registerIcons() {
    customIcons.forEach(item => {
      this.matIconRegistry.addSvgIcon(
        item.iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(item.url)
      );
    });
  }
}
